<template>
  <div class="vm-container login-container">
    <div class="auth__content login__box">
      <a
        class="back-link"
        @click="goToLogin()"
      >
        <font-awesome-icon
          size="1x"
          :icon="['fas', 'chevron-left']"
        />
        {{ $t('ManageIdentity.Views.Account.ForgotPasswordConfirmation.Login') }}
      </a>
      <br />
      <h1
        class="login__box__header"
        v-html="$t('ManageIdentity.Views.Account.ManageForgotPassword.Headline')"
      />
      <br />
      <div
        class="login__box__description__two"
        v-html="$t('ManageIdentity.Views.Account.ManageForgotPassword.SubHeadline')"
      />
      <br />
      <b-alert
        :show="showSuccess"
        variant="success"
      >
        <span v-html="$t('ManageIdentity.Views.Account.ForgotPasswordConfirmation.ForgotPasswordSuccessfully')" />
        <br />
        <span v-html="$t('ManageIdentity.Views.Account.ForgotPasswordConfirmation.Checkinbox')" />
      </b-alert>
      <b-alert
        :show="showUnsuccessful"
        variant="danger"
      >
        <div v-html="alertData" />
      </b-alert>
      <br />

      <b-form-group
        id="fieldset-1"
        :label="email"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="credentials.Email"
          type="email"
          :placeholder="emailPlaceholder"
          trim
          @keyup.enter="() => {
            if (emailState) {
              resetPassword()
            }
          }"
        />
      </b-form-group>
      <b-button
        :disabled="!emailState"
        variant="primary"
        class="login__box__login_btn"
        @click.prevent="resetPassword()"
      >
        <span v-html="$t('ManageIdentity.Views.Account.ManageForgotPassword.Submit')" />
      </b-button>
    </div>
  </div>
</template>

<script>
import accountPageMixins from '../../mixins/accountPageMixins'
import userState from '../../states/user'
import * as constants from '../../constants/constants'

export default {
  data() {
    return {
      credentials: {
        Email: '',
      },
      showSuccess: false,
      showUnsuccessful: false,
    }
  },
  mixins: [accountPageMixins],
  mounted() {
    const user = userState.getUser(this.getConfig.instance)
    if (user) userState.unsetUser(this.getConfig.instance)
  },
  computed: {
    emailRegex() {
      return constants.emailRegex
    },
    emailState() {
      return this.credentials.Email && this.emailRegex.test(this.credentials.Email)
    },
    email() {
      return this.$t('ManageIdentity.Views.Account.ManageForgotPassword.Email')
    },
    emailPlaceholder() {
      return this.$t('ManageIdentity.Views.Account.ManageForgotPassword.Email')
    },
  },
  methods: {
    resetPassword() {
      this.showSuccess = false
      this.showUnsuccessful = false
      this.passwordRetrieval(this.credentials).then((res) => {
        if (res.status === 404 || res.status === 400 || res.status === 401 || (res.status === 200 && !res.data)) this.showInvalidAlert(res.status)
        if (res.status === 200 && res.data) this.showSuccessAlert()
      })
    },
    showSuccessAlert() {
      this.showSuccess = true
    },
    showInvalidAlert(params) {
      if (params === 404) this.alertData = this.invalidText
      if (params === 401) this.alertData = this.unauthorizedText
      if (params === 400) this.alertData = this.badrequestText
      if (params === 200) this.alertData = this.$t('ManageIdentity.Views.Account.ForgotPasswordConfirmation.ForgotPasswordError')
      this.showUnsuccessful = true
    },
  },
}
</script>

<style lang="scss" scoped>
.back-link {
  cursor: pointer;
  font-weight: bold;
  svg {
    margin-right: 0.5rem;
  }
}

.login-container{
  display: flex;
  justify-content: center;

  .login__box{
    display: flex;
    justify-content: center;
    flex-direction: column;

    .login__box__login_btn{
      max-width: 200px;
    }
    .login__box__login_btn:disabled{
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .login__box__header, .login__box__description{
      display: flex;
      justify-content: center;
    }

    .login__box__description__two{
      display: flex;
    }

    .login__box__checkbox_link{
      display: flex;
      justify-content: space-between;}
  }
}

@media (max-width: 668px) {
  .login__box__checkbox_link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.auth__content {
  width: 100vw;
  max-width: 800px;
  margin-top: 10px;
  padding: 15px;
}
</style>
